import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { ModalNewGroupComponent } from 'projects/access-control/src/app/UI/components/modal-new-group/modal-new-group.component';
import { TranslateService } from '@mangosoft/mango-layout';
import { Subscription } from 'rxjs';

interface DataTranslateGeneral {
	title: string;
	buttonEdit: string;
	textName: string;
	textId: string;
	textEmail: string;
	textGroups: string;
	textUser: string;
}
@Component({
	selector: 'app-general',
	templateUrl: './general.component.html',
	styleUrls: ['./general.component.scss'],
})
export class GeneralComponent implements OnInit, OnDestroy {
	@Input() group: Groups = {} as Groups;
	@Input() isSubGroup: boolean = false;
	@Input() loading: boolean = false;
	isEditGroups = true;
	translateGeneral: DataTranslateGeneral = {} as DataTranslateGeneral;
	subscriptionTranslate!: Subscription;
	constructor(public dialog: MatDialog, private translateService: TranslateService) {}

	ngOnInit(): void {
		this.getTranslate();
	}

	updateGroup() {
		const dialogRef = this.dialog.open(ModalNewGroupComponent, {
			height: '450px',
			width: '687px',
			data: {
				type: this.isSubGroup ? 'updateSelectedSubGroup' : 'updateSelectedGroup',
				group: this.group,
			},
		});
	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateGeneral = data.pages.groups.tabs.infoTabs.general;
		});
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
